import { Autocomplete } from "@clockwise/design-system";
import classNames from "classnames";
import React from "react";
import { getTimeZones, normalizeZone } from "../../util/time-zone.util";

export interface Props {
  onChange: (timeZone: string) => void;
  value?: string;
  className?: string;
}

const timeZonesDict = getTimeZones();

export const TimeZonePicker = ({ onChange, value, className }: Props) => {
  const timeZones = Object.keys(timeZonesDict);
  const timeZone = Object.entries(timeZonesDict).find(
    ([_, tzValue]) => tzValue === (value ? normalizeZone(value) : value),
  )?.[0];

  const handleChange = (key: string) => {
    const value = timeZonesDict[key];
    onChange(value);
  };

  return (
    <div className={classNames("cw-w-full", className)}>
      <Autocomplete
        aria-label="your timezone"
        data={timeZones}
        fullWidth
        onChange={handleChange}
        value={timeZone}
      />
    </div>
  );
};
